import SuperFetchV2 from '../../superFetchV2';
import { removeNull } from '../../utils';
import queryString from 'query-string';
import { PointLogsFindResponseBodyDto } from '../../../types/api/point-logs';
import { PointLogsFindRequestBodyDto } from '../../../types/point';

export const PointApiV2 = {
  fetchPointLogs: (params: PointLogsFindRequestBodyDto): Promise<PointLogsFindResponseBodyDto> => {
    const filteredParams = removeNull(params);
    const queryParams = queryString.stringify({ ...filteredParams }, { skipEmptyString: true });
    return SuperFetchV2.get(`/point-logs?${queryParams}`);
  },
};
